export enum FilterMode {
	And = 0,
	Or = 1
}

export const FilterModeNames = {
	[FilterMode.And]: 'And',
	[FilterMode.Or]: 'Or',
};
